const isOptionsTooLong = (options, limit) => options.reduce((a, b) => (a.length > b.length ? a : b)).length > limit;
export default isOptionsTooLong;
